export const SET_INVOICETYPES          = 'SET_INVOICETYPES';
export const SET_INVOICETYPES_LOADING  = 'SET_INVOICETYPES_LOADING';
export const SET_INVOICETYPES_ERROR    = 'SET_INVOICETYPES_ERROR';
export const CLEAR_INVOICETYPES        = 'CLEAR_INVOICETYPES';
export const CLEAR_INVOICETYPES_ERROR  = 'CLEAR_INVOICETYPES_ERROR';

